import { ChangeDetectorRef, Component, HostListener, TemplateRef } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HeaderService } from './header.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    standalone: false
})
export class HeaderComponent {
  bucketurl = environment.bucketUrl;
  dialogRef!: MatDialogRef<any>;
  isDropdownOpen = false;
  notifications = [
    { type: 'new-leads', title: 'New Leads', description: 'You have 3 new leads assigned today', time: 'Today at 9:42 AM' },
    { type: 'follow-up', title: 'Follow Up', description: 'You have 3 leads in Follow Up today', time: 'Today at 9:42 AM' },
    { type: 'missed-calls', title: 'Missed Calls', description: 'You have 3 missed calls today', time: 'Today at 9:42 AM' }
  ];

  constructor(private toastr: ToastrService, private router: Router, public dialog: MatDialog, private cdr: ChangeDetectorRef, private headerService : HeaderService) { }
  openDialog(logout_pop: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(logout_pop, {
      width: '400px',
    })
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  logOut() {
    this.dialogRef.close();
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['']);
    this.toastr.success('Logged out!');
  }


  toggleDropdown() {
    this.isDropdownOpen = true;
    this.cdr.detectChanges(); // Manually trigger change detection
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement).closest('.notification-icon') || (event.target as HTMLElement).closest('.modal');
    if (!clickedInside) {
      this.closeDropdown();
    }
  }
  username: any = ''
  ngOnInit() {
    setTimeout(() => {
      this.getMasters()
    }, 0)
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        this.username = loginResponse.data?.user?.first_name;
      }
    }
  }

  getMasters() {
    this.headerService.getMasters().subscribe((response: any) => {
      let responseData: any = response.body
      if (responseData.responseCode == 200) {
        sessionStorage.setItem('masters', JSON.stringify(responseData.data));
      }
    })
  }
}